import React, { Component, Fragment } from 'react'
import { Breadcrumb, Card, Collapse, Icon, message, Popconfirm, Row, Tabs, Tooltip } from 'antd'
import { get, isEmpty, pick } from 'lodash'
import style from './style.css'
import Members from '../../../../../api/Members'
import PayQuery from '../../../../../api/PayQuery'
import Employees from '../../../../../api/Employees'
import Overview from '../Form/Overview'
import { execute, strVal } from '../../../../../modules/Utils'
import Documents from '../../../../Common/Documents/DocumentsCont'
import Statutory from '../Form/Statutory'
import InfoText from '../../../../../elements/InfoText'
import { withRouter } from 'react-router-dom'
import { compose } from 'recompose'
import State from '../../../../../elements/State'

const { Panel } = Collapse
const { TabPane } = Tabs

class ViewPayQuery extends Component {
  constructor(props) {
    super(props)
    this.key = props.match.params.key
    this.payQueryKey = get(props.match, 'params.payQueryKey')
    let payQuery = get(props.location, 'state.payQuery') || {}
    this.state = {
      created: false,
      submitting: false,
      fetching: false,
      employeeFetching: false,
      linesList: [],
      member: get(props.location, 'state.member') || {},
      employee: get(props.location, 'state.employee') || {},
      payQuery,
    }
    this.payQueryApi = new PayQuery()
    this.api = new Employees()
    this.memberApi = new Members()
  }

  async componentDidMount() {
    if (isEmpty(this.state.member)) {
      await this.fetch()
    }
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      const employeeResponse = await this.api.getMember(this.key)
      const memberResponse = await this.memberApi.get(this.key)
      let payQuery = await this.payQueryApi.get(this.payQueryKey)
      let member = await memberResponse.json()
      let employee = await employeeResponse.json()
      this.setState({
        member,
        employee,
        payQuery,
        fetching: false,
        employeeFetching: false,
      })
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        fetching: false,
        employeeFetching: false,
      })
    }
  }

  handleOps = async (operation, payQuery) => {
    const { activate, terminate, suspend, remove } = this.payQueryApi
    const { employee, member } = this.state
    const { history } = this.props

    switch (operation) {
      case 'activate':
        await execute(this, activate.bind(this, pick(payQuery, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'update':
        history.push({
          pathname: `update`,
          state: { payQuery, employee, member },
        })
        break

      case 'terminate':
        await execute(this, terminate.bind(this, pick(payQuery, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break

      case 'suspend':
        await execute(this, suspend.bind(this, pick(payQuery, ['_key', '_rev', '_id'])), message)
        await this.fetch()
        break
      case 'remove':
        await execute(this, remove.bind(this, pick(payQuery, ['_key', '_rev', '_id'])), message)
        history.replace({
          pathname: `/people/member/${member._key}/`,
          state: { payQuery, employee, member },
        })
        break
    }
  }
  Operations = ({ payQuery, status, ...rest }) => {
    let ops = []
    if (status !== 'Terminated')
      ops.push(
        <span>
          <a onClick={() => this.handleOps('update', payQuery)}>Update</a>
        </span>
      )
    if (status === 'Active' || status === 'Suspended')
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={'Are you sure to Terminate?'}
            onConfirm={() => this.handleOps('terminate', payQuery)}
            okText="Yes"
            cancelText="No">
            <a>Terminate</a>
          </Popconfirm>
        </span>
      )
    if (status === 'Active')
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={'Are you sure to Suspend?'}
            onConfirm={() => this.handleOps('suspend', payQuery)}
            okText="Yes"
            cancelText="No">
            <a>Suspend</a>
          </Popconfirm>
        </span>
      )

    if (status === 'Terminated' || status === 'Suspended' || status === 'Inactive')
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={'Are you sure to Activate this Pay Query?'}
            onConfirm={() => this.handleOps('activate', payQuery)}
            okText="Yes"
            cancelText="No">
            <a>Activate</a>
          </Popconfirm>
        </span>
      )

    if (status === 'Inactive')
      ops.push(
        <span>
          <Popconfirm
            placement="left"
            title={'Are you sure  to Remove this Pay Query?'}
            onConfirm={() => this.handleOps('remove', payQuery)}
            okText="Yes"
            cancelText="No">
            <a>Remove</a>
          </Popconfirm>
        </span>
      )
    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }
  updatePayQuery = (attribute, value) => {
    const { payQuery } = this.state
    this.setState({
      payQuery: Object.assign({}, payQuery, { [attribute]: value }),
    })
  }

  render() {
    const { member, employee, fetching, payQuery } = this.state
    const { history } = this.props
    const { Operations } = this
    return (
      <Fragment>
        <Card loading={fetching}>
          <Row className={style.pageHeader}>
            <Breadcrumb>
              <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="#/people/dashboard/#team">Team List</Breadcrumb.Item>
              <Breadcrumb.Item href={`#/people/member/${this.key}/`}>{member.fn}</Breadcrumb.Item>
              <Breadcrumb.Item>{payQuery.code}</Breadcrumb.Item>
            </Breadcrumb>
            <div className={style.title}>
              <h2 className={'icon-text-header'}>
                <Icon
                  type="barcode"
                  style={{
                    marginRight: '5px',
                    color: '#08c',
                  }}
                />
                <Tooltip title="Pay Query  Code">{strVal(payQuery, 'code')}</Tooltip>
                {' - ' + strVal(payQuery, 'title')}
              </h2>
              <State value={strVal(payQuery, 'status')} />
              <Operations style={{ marginTop: '10px' }} payQuery={payQuery} status={strVal(payQuery, 'status')} />
            </div>
            <p className={style.paragraph}>{member.fn} Pay Query Details</p>
          </Row>
        </Card>

        <Row style={{ paddingTop: '10px' }}>
          <Card loading={fetching} style={{ minHeight: '542px' }}>
            <Row style={{ paddingTop: '10px' }}>
              <Tabs defaultActiveKey="dashboard">
                <TabPane
                  tab={
                    <span>
                      <Icon type="info-circle" />
                      Details
                    </span>
                  }
                  key="dashboard">
                  <InfoText text={'To Update Pay Query Details please click on Update Button above.'} />
                  <Collapse bordered={false} defaultActiveKey={['1']}>
                    <Panel header={<h3>Pay Query Overview</h3>} key="1">
                      <Overview
                        employee={employee}
                        member={member}
                        ref={(child) => {
                          this.overviewCmp = child
                        }}
                        payQuery={payQuery}
                        type={'view'}
                        updatePayQuery={this.updatePayQuery}
                      />
                    </Panel>
                    <Panel header={<h3>Statutory Details </h3>} key="statutory">
                      <Statutory
                        updatePayQuery={this.updatePayQuery}
                        employee={employee}
                        payQuery={payQuery}
                        loading={fetching}
                        type={'view'}
                      />
                    </Panel>
                  </Collapse>
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="folder-open" />
                      Documents
                    </span>
                  }
                  key="docs">
                  <Documents owner={payQuery} />
                </TabPane>
              </Tabs>
            </Row>
          </Card>
        </Row>
      </Fragment>
    )
  }
}

export default compose(withRouter)(ViewPayQuery)
